// Dependencies.
import styled from 'styled-components'

import { Input } from './Inputs/Input'
import { fadeIn } from '../utils/keyframes'
import { P } from './P'
import { colors } from '../utils'

// Div.
const Div = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 15px;

  .icon {
    flex-shrink: 0;
    height: 40px;
    margin-right: 15px;
    width: 40px;
  }

  .readOnlyContent {
  }

  ${Input} {
    animation: ${fadeIn} 300ms ease-out;

    &::placeholder {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.6px;
      line-height: 140%;
    }
  }

  .errorContainer {
    margin-top: 8px;
    text-align: left;
  }

  .inputError {
    border-color: ${colors.red} !important;
    opacity: 0.6;
  }

  .inputContainer {
    display: flex;
    flex-wrap: wrap;
    width: -moz-available;
    width: -webkit-fill-available;
    width: fill-available;
  }
`

// Props.
interface Props {
  icon?: string
  onBlur?: () => void
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  placeholder?: string
  readOnly?: boolean
  value: string
  errors?: string[]
}

// List Item Input.
export const ListItemInput: React.FC<Props> = (props) => {
  // Props.
  const {
    icon,
    onBlur,
    onChange,
    onKeyDown,
    placeholder,
    readOnly,
    value,
    errors,
  } = props

  // Ready Only && !Value.
  if (readOnly && !value) return null

  // ..
  return (
    <Div className="listItem">
      {/* Icon. */}
      {icon && <img className="icon" src={icon} />}

      <div className="inputContainer">
        {/* Input. */}
        {(readOnly && <div className="readOnlyContent">{value}</div>) || (
          <Input
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            value={value}
            className={`${errors && errors.length > 0 ? 'inputError' : ''}`}
          />
        )}
        {errors && errors.length > 0 && (
          <div className="errorContainer">
            {errors.map((error, index) => {
              return (
                <P
                  key={index}
                  className="detail"
                  style={{ color: `${colors.red}` }}>
                  {error}
                </P>
              )
            })}
          </div>
        )}
      </div>
    </Div>
  )
}
